import { yupResolver } from '@hookform/resolvers/yup'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import SidePopover from '@/components/side-popover/SidePopover.jsx'
import CustomerCostForm from '@/pages/customers/detail/customer-form/costs-form/CustomerCostForm.jsx'
import {
    validationSchema,
    DEFAULT_COSTS_CUSTOMER_MOCK,
} from '@/pages/customers/detail/customer-form/costs-form/customerCostsForm.schema.js'

const CustomerCostFormWrapper = ({
    dataForm,
    closeModal,
    openDialogDelete,
    isEdit,
    suppliers,
}) => {
    const { t } = useTranslation()

    const methods = useForm({
        shouldUnregister: false,
        mode: 'all',
        reValidateMode: 'onChange',
        nativeValidation: false,
        shouldFocusError: true,
        resolver: yupResolver(validationSchema),
        defaultValues: DEFAULT_COSTS_CUSTOMER_MOCK,
    })

    const {
        formState: { isDirty },
    } = methods

    return (
        <FormProvider {...methods}>
            <SidePopover
                onClose={() => closeModal(isDirty)}
                isDirty={isDirty}
                title={
                    isEdit
                        ? t(`customer.form.edit_title`)
                        : t(`customer.form.create_title`)
                }
            >
                <CustomerCostForm
                    isEdit={isEdit}
                    closeModal={closeModal}
                    dataForm={dataForm}
                    openDialogDelete={openDialogDelete}
                    suppliers={suppliers}
                />
            </SidePopover>
        </FormProvider>
    )
}

export default CustomerCostFormWrapper

CustomerCostFormWrapper.propTypes = {
    dataForm: PropTypes.object,
    onClose: PropTypes.func,
    closeModal: PropTypes.func,
    openDialogDelete: PropTypes.func,
    isEdit: PropTypes.bool,
    sals: PropTypes.array,
    suppliers: PropTypes.array,
}
